import { RequirementTypes } from '~/lib/types/enums';
import useQuoteRequirements from './use-quote-requirements';
import { useMemo } from 'react';

export function useShopRequirements(type: RequirementTypes.ORIGIN | RequirementTypes.DESTINATION) {
  const { requirements, loading } = useQuoteRequirements();

  const shopRequirement = useMemo(
    () => requirements[type]?.rules?.find((r) => r.key === 'shopId' || r.key === 'ShopId'),
    [requirements, type]
  );

  return {
    shopRequirement,
    loading
  };
}
